module.exports = __webpack_public_path__ + "img/add-circle.7562042b.svg";